module.exports = __webpack_public_path__ + "img/2.7e4d5b26.png";